import Vue from 'vue';

export default Vue.extend({
  methods: {
    generateBizStockImage(id: string): string {
      const stockImages: string[] = [
        require('@/assets/svg/add_to_cart.svg'),
        require('@/assets/svg/empty_cart.svg'),
      ];

      for (const c of id.split('')) {
        let num = +c;

        if (!isNaN(num)) {
          return stockImages[num % 2];
        }
      }

      return stockImages[0];
    },
  },
});
